module.exports = __webpack_public_path__ + "static/media/RessourcesPage1.15b85a89.svg";